import React, { useState } from 'react';
import { useStore } from '../../store/useStore';
import { CheckCircle2, AlertCircle, ArrowLeft } from 'lucide-react';
export function PostPickup() {
  const {
    products,
    setShopperView,
    reportOrderChange
  } = useStore();
  const [step, setStep] = useState<'prompt' | 'report'>('prompt');
  // For demo, just use the first Stashed product as the one they picked up
  const product = products.find(p => p.status === 'Stashed') || products[0];
  const handleMatch = () => {
    setShopperView('Browse');
  };
  const handleReport = (reason: string) => {
    // In a real app we'd have the orderId. For demo, we'll just use a dummy orderId or find one.
    // We'll just pass a dummy orderId that triggers the product status change in the store.
    // Actually, reportOrderChange needs an orderId. Let's just find an order for this product.
    // Or we can just add a specific action for this demo.
    reportOrderChange('o1', reason); // assuming o1 is for p1
    setShopperView('ClaimResult');
  };
  if (step === 'report') {
    return <div className="flex flex-col h-full bg-[#F4F5F6] p-4 pt-12" data-id="element-424">
        <div className="bg-white rounded-[18px] p-6 shadow-sm" data-id="element-425">
          <button onClick={() => setStep('prompt')} className="p-2 -ml-2 mb-4 rounded-full hover:bg-gray-100 text-[#252935]" data-id="element-426">
            <ArrowLeft className="w-5 h-5" data-id="element-427" />
          </button>
          <h2 className="text-xl font-bold text-[#252935] mb-6" data-id="element-428">
            What was off?
          </h2>

          <div className="space-y-3" data-id="element-429">
            {['Out of stock', 'Wrong price', 'Different product'].map(reason => <button key={reason} onClick={() => handleReport(reason)} className="w-full text-left p-4 rounded-xl border border-[rgba(37,41,53,0.12)] font-medium text-[#252935] hover:border-[#00CDBE] hover:bg-[#E9FAF8] transition-colors" data-id="element-430">
                  {reason}
                </button>)}
          </div>
        </div>
      </div>;
  }
  return <div className="flex flex-col h-full bg-[#F4F5F6] p-4 pt-12" data-id="element-431">
      <div className="bg-white rounded-[18px] p-6 shadow-sm flex flex-col items-center text-center" data-id="element-432">
        <img src={product.image} alt={product.name} className="w-16 h-16 rounded-xl object-cover mb-4" data-id="element-433" />
        <h1 className="text-2xl font-bold text-[#252935] mb-2" data-id="element-434">
          How was your pickup at {product.dispensaryName}?
        </h1>
        <p className="text-[#60646F] mb-8" data-id="element-435">
          Did your order match what was shown?
        </p>

        <div className="w-full space-y-3" data-id="element-436">
          <button onClick={handleMatch} className="w-full bg-[#00CDBE] text-white font-bold py-3.5 rounded-full flex items-center justify-center gap-2 hover:bg-[#00B8AA] transition-colors" data-id="element-437">
            <CheckCircle2 className="w-5 h-5" data-id="element-438" />
            It matched
          </button>
          <button onClick={() => setStep('report')} className="w-full bg-white text-[#252935] border border-[rgba(37,41,53,0.12)] font-bold py-3.5 rounded-full flex items-center justify-center gap-2 hover:bg-gray-50 transition-colors" data-id="element-439">
            <AlertCircle className="w-5 h-5" data-id="element-440" />
            Something was off
          </button>
        </div>
      </div>
    </div>;
}